import { css } from '@emotion/react'
import {
  Button,
  Calendar as ReactAriaCalendar,
  CalendarCell,
  CalendarGrid,
  Heading,
} from 'react-aria-components'
import { mTheme } from '../../../style/themes'

const styles = {
  container: css({
    width: 'fit-content',
    maxWidth: '100%',
    color: mTheme.fontColor.plain.primary,
    // border: '2px solid ' + mTheme.borderColor.secondary,
  }),
  header: css({
    display: 'flex',
    alignItems: 'center',
    margin: '0 4px .5rem 4px',
  }),
  heading: css({
    flex: 1,
    margin: 0,
    textAlign: 'center',
    fontSize: mTheme.fontSize.M,
  }),
  button: css({
    width: '2rem',
    height: '2rem',
    padding: 0,
  }),

  cell: css({
    width: '2rem',
    lineHeight: '2rem',
    textAlign: 'center',
    borderRadius: '6px',
    cursor: 'default',
    outline: 'none',
    margin: '1px',
    forcedColorAdjust: 'none',
    color: mTheme.fontColor.plain.secondary,

    '&[data-outside-month]': {
      display: 'none',
    },

    '&[data-pressed]': {
      background: mTheme.backgroundColor.secondary,
    },

    '&[data-focus-visible]': {
      outline: '2px solid ' + mTheme.color.focusRing,
      outlineOffset: '2px',
    },

    '&[data-selected]': {
      background: mTheme.backgroundColor.secondary,
      color: mTheme.fontColor.plain.primary,
    },

    '&[aria-disabled]': {
      color: mTheme.backgroundColor.secondary,
    },
    '&[data-unavailable]': {
      color: mTheme.backgroundColor.secondary,
    },
  }),

  '&[slot=errorMessage]': {
    fontSize: '12px',
    color: mTheme.fontColor.disabled,
  },
}

export function Calendar() {
  return (
    <ReactAriaCalendar css={styles.container}>
      <header css={styles.header}>
        <Button css={styles.button} slot="previous">
          <i className="fas fa-chevron-left" />
        </Button>
        <Heading css={styles.heading} />
        <Button css={styles.button} slot="next">
          <i className="fas fa-chevron-right" />
        </Button>
      </header>
      <CalendarGrid>
        {(date) => <CalendarCell css={styles.cell} date={date} />}
      </CalendarGrid>
    </ReactAriaCalendar>
  )
}
